import { styled } from 'next-yak'

export const InlineSvg = styled.svg`
  display: inline-block;
  color: inherit;
  fill: currentColor;
`
